import React from 'react';

function ProfileIcon({ width = 17, height = 18, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 17 18">
      <g>
        <path d="M12.3617374,5.53724817 C12.3617374,3.02444986 10.4622536,1 8.13543047,1 C5.80936366,1 3.91000009,3.02458106 3.91000009,5.53724817 C3.91000009,8.04991528 5.80936366,10.0744963 8.13543047,10.0744963 C10.4622536,10.0744963 12.3617374,8.05004648 12.3617374,5.53724817 Z M13.3617374,5.53724817 C13.3617374,8.5885912 11.0292832,11.0744963 8.13543047,11.0744963 C5.24230347,11.0744963 2.91000009,8.58843346 2.91000009,5.53724817 C2.91000009,2.48606288 5.24230347,0 8.13543047,0 C11.0292832,0 13.3617374,2.48590514 13.3617374,5.53724817 Z" />
        <path d="M10.8493609,9.9112372 L11.2612429,9 C14.3369505,10.3902292 16.382411,13.7333529 16.382411,17.4935421 L16.382411,17.9935421 L0,17.9935421 L0,17.4935421 C0,13.7352869 2.04450812,10.3922822 5.11830756,9.00103866 L5.53065139,9.91206696 C2.95803035,11.0764703 1.18341423,13.8269971 1.01339373,16.9935421 L15.3690251,16.9935421 C15.1990123,13.8253735 13.4236009,11.0748015 10.8493609,9.9112372 Z" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default ProfileIcon;
